import { render, staticRenderFns } from "./inputTabPendidikan.vue?vue&type=template&id=e5849798"
import script from "./inputTabPendidikan.vue?vue&type=script&lang=js"
export * from "./inputTabPendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports